// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20e43684","726":"7b005202"}[chunkId] + ".chunk.js";
};